var map = {
	"./advertorial.svg": 163,
	"./album.svg": 164,
	"./analysis.svg": 165,
	"./anchor.svg": 166,
	"./android-block.svg": 167,
	"./android-small.svg": 168,
	"./android.svg": 169,
	"./angle-down.svg": 170,
	"./angle-left.svg": 171,
	"./angle-right.svg": 172,
	"./angle-up.svg": 173,
	"./aquarius.svg": 174,
	"./aries.svg": 175,
	"./arrow-left.svg": 176,
	"./arrow-right.svg": 177,
	"./art-director.svg": 178,
	"./author.svg": 179,
	"./authoranchor.svg": 180,
	"./automobile.svg": 181,
	"./brandconnect.svg": 182,
	"./breaking-news.svg": 183,
	"./bullet-arrow.svg": 184,
	"./bundle.svg": 185,
	"./business.svg": 186,
	"./cancel.svg": 187,
	"./cancer.svg": 188,
	"./canvas.svg": 189,
	"./capricorn.svg": 190,
	"./cartoonist.svg": 191,
	"./cinema.svg": 192,
	"./clapboard.svg": 193,
	"./clipboard.svg": 194,
	"./close.svg": 195,
	"./comm-album.svg": 196,
	"./comm-automobile.svg": 197,
	"./comm-children.svg": 198,
	"./comm-cinema.svg": 199,
	"./comm-entertainment.svg": 200,
	"./comm-environment.svg": 201,
	"./comm-finance.svg": 202,
	"./comm-gadgets.svg": 203,
	"./comm-health.svg": 204,
	"./comm-lifestyle.svg": 205,
	"./comm-news.svg": 206,
	"./comm-science.svg": 207,
	"./comm-spiritual.svg": 208,
	"./comm-sports.svg": 209,
	"./comm-technology.svg": 210,
	"./comm-video.svg": 211,
	"./comm-vikatan-plus.svg": 212,
	"./comm-women.svg": 213,
	"./comm-world-cup.svg": 214,
	"./comment.svg": 215,
	"./creative-director.svg": 216,
	"./data.svg": 217,
	"./designed.svg": 218,
	"./download.svg": 219,
	"./edited-by.svg": 220,
	"./email.svg": 221,
	"./environment.svg": 222,
	"./exclusivedeals.svg": 223,
	"./facebook-bg.svg": 224,
	"./facebook.svg": 225,
	"./filter-icon.svg": 226,
	"./filter.svg": 227,
	"./food-stylist.svg": 228,
	"./gallery.svg": 229,
	"./gemini.svg": 230,
	"./group.svg": 231,
	"./health.svg": 232,
	"./hexbackground.svg": 233,
	"./illustrator-t1.svg": 234,
	"./illustrator.svg": 235,
	"./infographer.svg": 236,
	"./instagram.svg": 237,
	"./interviews.svg": 238,
	"./ios-block.svg": 239,
	"./ios-small.svg": 240,
	"./ios.svg": 241,
	"./jokes.svg": 242,
	"./leo.svg": 243,
	"./libra.svg": 244,
	"./lifestyle.svg": 245,
	"./line-arrow-next.svg": 246,
	"./line-arrow-prev.svg": 247,
	"./linkedin.svg": 248,
	"./magazines.svg": 249,
	"./minus.svg": 250,
	"./mobile-share.svg": 251,
	"./moderated.svg": 252,
	"./narrated.svg": 253,
	"./news.svg": 254,
	"./newsletter.svg": 255,
	"./newslettericon.svg": 256,
	"./pen.svg": 257,
	"./photo.svg": 258,
	"./photographer.svg": 259,
	"./photostory.svg": 260,
	"./pisces.svg": 261,
	"./plus.svg": 262,
	"./poems.svg": 263,
	"./premium.svg": 264,
	"./producer.svg": 265,
	"./proofread.svg": 266,
	"./published-by.svg": 267,
	"./published.svg": 268,
	"./rss.svg": 269,
	"./sagitarius.svg": 270,
	"./scorpio.svg": 271,
	"./script-writer.svg": 272,
	"./scripted.svg": 273,
	"./search.svg": 274,
	"./share-alt.svg": 275,
	"./share.svg": 276,
	"./shortstories.svg": 277,
	"./slider-next.svg": 278,
	"./slider-prev.svg": 279,
	"./socialshare.svg": 280,
	"./sort.svg": 281,
	"./sound.svg": 282,
	"./speaker.svg": 283,
	"./spiritual.svg": 284,
	"./sponsored.svg": 285,
	"./sports.svg": 286,
	"./stylist.svg": 287,
	"./taurus.svg": 288,
	"./technology.svg": 289,
	"./trending.svg": 290,
	"./twitter.svg": 291,
	"./user.svg": 292,
	"./video-editor.svg": 293,
	"./video.svg": 294,
	"./videographer.svg": 295,
	"./vikatan-tv.svg": 296,
	"./vikatanconnect.svg": 297,
	"./vikatantv.svg": 298,
	"./virgo.svg": 299,
	"./whatsapp.svg": 300,
	"./writtenarticles.svg": 301,
	"./writtenstory.svg": 302,
	"./youtube.svg": 303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 162;